import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Initialize ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

const calculateX = () => {
    const blocks = $('.module--banner__wrapper__images__items').length - 1;
    const itemsWith = $('.module--banner__wrapper__images__items').width();
    const deviceWidth = $(document).width() / 2;

    const lastItemCount = $('.module--banner__wrapper__images .module--banner__wrapper__images__items:last-child .module--banner__wrapper__images__items__image').length;
    let lastItemWidth;
    let spacing = 35;

    if(lastItemCount < 3) {
        lastItemWidth = 472 + (spacing * 1);
    }

    if (lastItemCount < 4 && lastItemCount > 2) {
        lastItemWidth = (472 + 292) + (spacing * 2);
    }

    if (lastItemCount > 3) {
        lastItemWidth = itemsWith;
    }

    return `-${(itemsWith * blocks + lastItemWidth) - deviceWidth}px`;
}

if($('.module--banner__wrapper').length) {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.module--banner__wrapper',
            pin: true,
            scrub: true,
            start: 'top top',
            end: "+=300%",
        },
    });

    timeline
        .to('.module--banner__wrapper__images', {
            x: calculateX,
        })
    ;
}
